import { Injectable } from '@angular/core';
import { SystemAuthenticationService } from '@monex-sistemas/nueva-banca-digital-library';
import { TokenStatusService } from './token-status.service';
import { TokenUnlockService } from '../token-unlock/token-unlock.service';
import { Observable, first, firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as pubsub from "pubsub-js"
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class CheckTokenStatusService {

  modalRef: NgbModalRef
  constructor(
    private systemAuthenticationService: SystemAuthenticationService,
    private tokenStatusService: TokenStatusService,
    private tokenUnlockService: TokenUnlockService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private modalConfig: NgbModalConfig,
  ) {
    modalConfig.backdrop = 'static';
    modalConfig.keyboard = true;
  }

  async checkTokenStatus(translations: any, modalRef?: any ) {
    this.systemAuthenticationService.showLoading();
    let response
    try {
      response = await firstValueFrom(this.tokenStatusService.verifyTokenStatus())
    } catch (error) {
      console.log(error);
      this.systemAuthenticationService.hideLoading();
      const errMsg = translations.STATUS_TOKEN_ERROR
      const toast = {message: errMsg, type: 'error', summary: 'Error'}
      pubsub.publish("toast", toast)
      return
    }
    if (response?.statusCode === 'BL' || response?.statusCode === 'BI') {
      this.systemAuthenticationService.hideLoading();
      this.systemAuthenticationService.getRef()?.close()
      modalRef?.close();
      this.tokenUnlockService.openUnlockToken(translations, true);
      return false
    } else if (response?.statusCode === 'AC') {
      this.systemAuthenticationService.hideLoading();
      modalRef?.close();
      this.systemAuthenticationService.getRef()?.close()
      return true
    } else {
      modalRef?.close();
      this.systemAuthenticationService.getRef()?.close()
      return false
    }
  } 
}
